import { ITask } from '../../models/';
import { ITaskActionsService } from './tasks.actionCreator';
import { IDispatcherService, IDispatcher } from '../';

export interface ITaskStoreService {
    //getAll: (force?: boolean) => angular.IPromise<ITask[]>;
    //getOne: (guid: string) => angular.IPromise<ITask>;
    deleteAllCompleted: () => angular.IPromise<ITask[]>;
    //addOne: (element: ITask, type: OfflineTaskType) => angular.IPromise<ITask[]>;
}

export interface ITaskActionDispatcherService extends IDispatcherService<ITaskStoreService> { }

export class TaskActionDispatcherService implements ITaskActionDispatcherService {
    static serviceId = 'taskActionDispatcherService';

    static $inject = ['taskActionsService'];

    constructor(private _actionService: ITaskActionsService) { }

    getDispatcher(dispatch: Function): IDispatcher<ITaskStoreService> {
        const actionService = this._actionService;

        return {
            dispatcher: {
                //getAll: (force?: boolean) => dispatch(actionService.getAll(force)),
                //getOne: (guid: string) =>  dispatch(actionService.getOne(guid)),
                deleteAllCompleted: () => dispatch(actionService.deleteAllCompleted()),
                //addOne: (element: ITask, type: OfflineTaskType) => dispatch(actionService.addOne(element, type))
            }
        };
    }
}